module.exports = __webpack_public_path__ + "static/media/case.9a09e1b2.png";